/**
 * Footer — global site footer.
 *
 * 2026-07-27 CHANGE 8 — rewritten to a minimal neutral layout per the
 * user's CHANGES 1-8 batch. Prior footer surfaced Methodology,
 * Calibration, Backtest, and Accuracy links + an accuracy-claim
 * strapline; all of that is deleted. New shape:
 *
 *   Left:  brand mark + one-line tagline (no accuracy claim)
 *   Right: Terms · Privacy · Contact
 *   Bottom: © 2026 CODA
 *
 * Applied on every top-level page. Uses only the shared design
 * tokens (bg-paper / text-ink-soft) so it renders correctly on both
 * light and dark surrounding surfaces.
 */

import { Link } from "react-router-dom";

const LINK_CLASS =
    "text-[13px] text-ink-soft hover:text-ink transition-colors duration-150";

export default function Footer({ showPatentPending = false }) {
    return (
        <footer
            className="mt-32 border-t border-border/60 bg-paper"
            data-testid="site-footer"
            role="contentinfo"
        >
            <div className="max-w-[1500px] mx-auto px-6 py-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    {/* Left — brand + tagline */}
                    <div>
                        <div
                            className="font-wordmark font-black text-[24px] tracking-tight text-ink mb-1"
                            data-testid="footer-brand"
                        >
                            Tomauro
                        </div>
                        <div
                            className="text-[13px] text-ink-soft font-serif"
                            data-testid="footer-tagline"
                        >
                            Decision intelligence, calibrated.
                        </div>
                    </div>

                    {/* Right — legal + contact links */}
                    <nav
                        className="flex items-center gap-6"
                        aria-label="Footer links"
                        data-testid="footer-links"
                    >
                        <Link to="/legal/terms" className={LINK_CLASS} data-testid="footer-terms">
                            Terms
                        </Link>
                        <Link to="/legal/privacy" className={LINK_CLASS} data-testid="footer-privacy">
                            Privacy
                        </Link>
                        <Link to="/contact" className={LINK_CLASS} data-testid="footer-contact">
                            Contact
                        </Link>
                    </nav>
                </div>

                <div
                    className="mt-8 pt-6 border-t border-border/40 text-[12px] text-ink-soft"
                    data-testid="footer-copyright"
                >
                    © 2026 Tomauro
                    {showPatentPending && (
                        <span data-testid="footer-patent-pending"> · Patent Pending</span>
                    )}
                </div>
            </div>
        </footer>
    );
}
